import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";

export default function About() {
  const { t } = useLang();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-20 md:py-32 bg-[#D6E2F0]"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14">
        <div className="grid grid-cols-12 gap-8 md:gap-12 lg:gap-16 items-start">
          <div className="col-span-12 lg:col-span-5">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="relative"
            >
              <div className="aspect-[4/5] w-full bg-[#E1EAF3] border border-[#D5DEE8] overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1770656505709-fd97236989b9?crop=entropy&cs=srgb&fm=jpg&w=900&q=80"
                  alt="OMC inspection floor"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-px -right-px bg-[#1E3A5F] text-[#F4F7FB] px-5 py-3">
                <div className="font-mono text-[10px] tracking-[0.3em] uppercase">{t("about.bannerCountries")}</div>
                <div className="font-serif-display text-base md:text-lg mt-1">{t("about.bannerSub")}</div>
              </div>
            </motion.div>
          </div>

          <div className="col-span-12 lg:col-span-7">
            <p className="overline-maroon mb-5">{t("about.overline")}</p>
            <h2 className="font-serif-display font-light text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight text-[#0F1E33]">
              {t("about.title1")}{" "}
              <span className="italic text-[#1E3A5F]">{t("about.titleItalic")}</span>{" "}
              {t("about.title2")}
            </h2>
            <div className="hairline-gold w-24 mt-6" />

            <div className="mt-8 space-y-5 text-[#1F2D40] text-base md:text-lg leading-relaxed">
              <p>{t("about.p1")}</p>
              <p>{t("about.p2")}</p>
              <p>
                {t("about.p3prefix")}{" "}
                <a href="https://ranegroup.com/" target="_blank" rel="noreferrer" className="text-[#1E3A5F] underline-offset-4 hover:underline">
                  Rane
                </a>
                {t("about.p3suffix")}
              </p>
            </div>

            <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
              <Stat label={t("about.statRegistered")} value="2020" sub="Coventry, UK" />
              <Stat label={t("about.statOffices")} value="3" sub={t("about.statOfficesSub")} />
              <Stat label={t("about.statWarehouse")} value="EU" sub={t("about.statWarehouseSub")} />
              <Stat label={t("about.statSourcing")} value="100%" sub={t("about.statSourcingSub")} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ label, value, sub }) {
  return (
    <div className="border-l-2 border-[#B8860B] pl-4">
      <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#7B8AA0]">{label}</div>
      <div className="font-serif-display text-2xl md:text-3xl text-[#0F1E33] mt-1">{value}</div>
      <div className="text-xs md:text-sm text-[#4A5A70] mt-1">{sub}</div>
    </div>
  );
}
